import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedPosts } from "../../features/relatedPosts/relatedPostsSlice";
import RelatedPost from "./RelatedPost";

const RelatedPosts = ({ postId }) => {

  const { relatedPosts, isLoading, isError, error } = useSelector(
    (state) => state.relatedPosts
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchRelatedPosts(postId));
  }, [dispatch, postId]);

  // decide what to render
  let content = null;
  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (relatedPosts.length > 0 && !isError && !isLoading) {
    content = relatedPosts.map((relatedPost) => <RelatedPost key={relatedPost.id} relatedPost={relatedPost} />);
  } else if (isError && !isLoading && error) {
    content = <p>{error}</p>;
  } else if (!isLoading && !isError && relatedPosts.length === 0) {
    content = <p>No related posts found</p>;
  }


  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">
        {/* <!-- related post  --> */}
        {content}
        {/* <!-- related post ends --> */}
      </div>
    </aside>
  );
};

export default RelatedPosts;
